import { render, staticRenderFns } from "./StatusiVozila.vue?vue&type=template&id=7597a0c0&"
import script from "./StatusiVozila.vue?vue&type=script&lang=ts&"
export * from "./StatusiVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports